import { render, staticRenderFns } from "./CreateBrand.vue?vue&type=template&id=42c6c7fd&scoped=true&"
import script from "./CreateBrand.vue?vue&type=script&lang=js&"
export * from "./CreateBrand.vue?vue&type=script&lang=js&"
import style0 from "./CreateBrand.vue?vue&type=style&index=0&id=42c6c7fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6c7fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
